import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import '../modal/index.scss'

const ImageModal = ({ isOpen, imageUrl, imageAlt, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open')
    } else {
      document.body.classList.remove('modal-open')
    }

    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [isOpen])

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose()
      }
    }

    document.addEventListener('keydown', handleEscape)
    return () => {
      document.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  const modalContent = (
    <div 
      className="modal-overlay" 
      onClick={onClose}
    >
      <div 
        className="modal-container modal-medium" 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <div className="modal-title">
            <i className="zmdi zmdi-image"></i>
            <div>
              <h3>{imageAlt || 'Resim Görüntüleme'}</h3>
            </div>
          </div>
          <button className="modal-close" onClick={onClose}>
            <i className="zmdi zmdi-close"></i>
          </button>
        </div>
        <div className="modal-body text-center">
          {imageUrl ? (
            <img 
              src={imageUrl} 
              alt={imageAlt || 'Resim'} 
              style={{ 
                maxWidth: '100%', 
                maxHeight: '70vh', 
                objectFit: 'contain' 
              }}
              onError={(e) => {
                e.target.style.display = 'none'
                if (e.target.nextElementSibling) {
                  e.target.nextElementSibling.style.display = 'block'
                }
              }}
            />
          ) : null}
          <div style={{ display: imageUrl ? 'none' : 'block', padding: '40px' }}>
            <i className="zmdi zmdi-image" style={{ fontSize: '64px', color: '#999' }}></i>
            <p className="m-t-10">Resim yüklenemedi</p>
          </div>
        </div>
      </div>
    </div>
  )

  return createPortal(modalContent, document.body)
}

export default ImageModal

